import { useMutation } from '@tanstack/react-query';
import { updateLineItemQuantities as clientUpdateLineItemQuantities } from 'typescript/clients/solidshop/cart_client';
import { captureException } from '@sentry/react';
import { CustomError } from 'typescript/utilities/custom_error';
import { MUTATION_KEYS } from 'typescript/constants/react_query';

export const useUpdateLineItemQuantities = () => {
  const { mutate: updateLineItemQuantities, ...rest } = useMutation({
    mutationKey: [MUTATION_KEYS.UPDATE_LINE_ITEM_QUANTITIES],
    mutationFn: clientUpdateLineItemQuantities,
    onError: (error) => {
      captureException(
        new CustomError(MUTATION_KEYS.UPDATE_LINE_ITEM_QUANTITIES, error),
      );
    },
  });

  return { updateLineItemQuantities, ...rest };
};
